import styled, { css } from 'styled-components'
import { ArrowDownIcon } from '@velasca/icons/arrow-down'

interface ContainerProps {
  buttonType: 'prev' | 'next'
}

export const Container = styled.div<ContainerProps>`
  position: absolute;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  background: rgba(245, 245, 245, 0.5);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  width: 3.2rem;
  height: 3.2rem;
  transition: transform 0.2s ease-in-out;

  @media screen and (min-width: 992px) {
    &:hover {
      transform: scale(1.2);
      background: #fff;
    }
  }

  &.swiper-button-disabled {
    display: none;
  }

  ${(props) => {
    return (
      props.buttonType === 'prev' &&
      css`
        left: 1.2rem;
      `
    )
  }}

  ${(props) => {
    return (
      props.buttonType === 'next' &&
      css`
        right: 1.2rem;
      `
    )
  }}
`

export const ArrowIcon = styled(ArrowDownIcon)`
  margin-top: 0.2rem;
`
